import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const X01 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="x-01">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L12 10.5858L19.2929 3.2929C19.6834 2.90237 20.3166 2.90237 20.7071 3.2929C21.0976 3.68342 21.0976 4.31659 20.7071 4.70711L13.4142 12L20.7071 19.2929C21.0976 19.6834 21.0976 20.3166 20.7071 20.7071C20.3166 21.0976 19.6834 21.0976 19.2929 20.7071L12 13.4142L4.70711 20.7071C4.31658 21.0976 3.68342 21.0976 3.29289 20.7071C2.90237 20.3166 2.90237 19.6834 3.29289 19.2929L10.5858 12L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
